import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ob-trub',
  templateUrl: './ob-trub.component.html',
  styleUrls: ['./ob-trub.component.scss']
})
export class ObTrubComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
